import { Message } from '@theme-ui/components';
import React from 'react';
export default {
  Message,
  React
};